(function() {

  // Footer padding
  function setMainWrapperPadding() {
    var footer = document.querySelector('.footerWrapper');
    if (!footer) return;
    var mainWrapper = document.querySelector('.mainWrapper');
    if (!mainWrapper) return;
    mainWrapper.style.marginBottom = footer.offsetHeight + 'px';
  }
  setMainWrapperPadding();
  window.addEventListener('resize', function() { setMainWrapperPadding(); });

  // Fix: theme-hot-reload.js fires shopify:section:load unconditionally, causing
  // Broadcast's I(document) to register duplicate document-level listeners.
  // Every click opens the filter then immediately closes it.
  //
  // Fix: attach a CAPTURE-phase listener to the filter button.
  // Capture fires before any bubble-phase listener, so stopImmediatePropagation
  // prevents all of theme.js's duplicate handlers from running.
  // We then own the toggle entirely.
  window.addEventListener('load', function() {
    document.querySelectorAll('[aria-controls="filter-groups"]').forEach(function(btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));

      // Sync panel state with button's initial aria-expanded on load
      if (panel) {
        if (btn.getAttribute('aria-expanded') === 'true') {
          panel.classList.add('expanded');
          panel.classList.remove('no-mobile-animation');
        }
      }

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        // Stop ALL further listeners (bubble-phase handlers, document-level handlers)
        e.stopImmediatePropagation();

        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');

        if (panel) {
          if (isOpen) {
            panel.classList.remove('expanded');
          } else {
            panel.classList.add('expanded');
            panel.classList.remove('no-mobile-animation');
          }
          var onStart = function() {
            panel.classList.add('expanding');
            panel.removeEventListener('transitionstart', onStart);
          };
          var onEnd = function() {
            panel.classList.remove('expanding');
            panel.removeEventListener('transitionend', onEnd);
          };
          panel.addEventListener('transitionstart', onStart);
          panel.addEventListener('transitionend', onEnd);
        }
      }, true); // true = capture phase: fires before theme.js bubble-phase listeners
    });
  });

  // Fix: PR mentions / press logos section (sections/section-press-logos.liquid).
  // The logo row is initialised as a draggable Flickity carousel, and Flickity
  // preventDefaults both pointerdown and click on its cells. That kills navigation
  // on <a class="logos__slide__link">, so the brand logos never open their
  // collection page even though the block links are configured correctly.
  //
  // Fix: CAPTURE-phase click delegate that navigates manually. A drag is told apart
  // from a click by pointer movement, so swiping the carousel still works.
  (function() {
    var down = false, startX = 0, startY = 0, moved = false;

    document.addEventListener('pointerdown', function(e) {
      down = true; startX = e.clientX; startY = e.clientY; moved = false;
    }, true);

    document.addEventListener('pointermove', function(e) {
      if (down && (Math.abs(e.clientX - startX) > 6 || Math.abs(e.clientY - startY) > 6)) {
        moved = true;
      }
    }, true);

    document.addEventListener('pointerup', function() { down = false; }, true);

    document.addEventListener('click', function(e) {
      var link = e.target && e.target.closest ? e.target.closest('a.logos__slide__link') : null;
      if (!link || moved) return;

      var href = link.getAttribute('href');
      if (!href || href === '#') return;

      e.stopImmediatePropagation();

      if (e.metaKey || e.ctrlKey || e.button === 1) {
        window.open(href, '_blank');
      } else {
        window.location.assign(href);
      }
    }, true);
  })();

})();
